import { Container } from "@chakra-ui/react";
import TeaserCard, { TeaserFields } from "components/ui/TeaserCard";

export type DownloadProps = {
    fields: TeaserFields;
};

const Download = (props: DownloadProps) => {
    return (
        <Container variant="module">
            <TeaserCard variant="imageLeft" download fields={props.fields} />
        </Container>
    );
};
export default Download;
